import {create} from 'zustand'
import {devtools} from 'zustand/middleware'
import BrandEnum from "../types/BrandEnum";

/**
 * This is the interface for the methods that will be available to the store.
 */
interface AppStateMethods {
  setEditPaymentFreeMonths: (editPaymentFreeMonths: boolean) => void
  setSignProcessStarted: (signProcessStarted: boolean) => void
  setGoNextDisabled: (nextDisabled: boolean) => void
  setGoNextTooltip: (tooltip: string | undefined) => void
  setRedirectBrand: (brand: BrandEnum) => void
  setIsAdmin: (isAdmin: boolean) => void
  setIsRecalculate: (isRecalculate: boolean) => void
}

/**
 * This is the interface for the state that will be available to the store.
 */
export interface AppState extends AppStateMethods {
  editPaymentFreeMonths: boolean
  signProcessStarted: boolean
  goNextDisabled: boolean
  goNextTooltip: string | undefined
  redirectBrand: BrandEnum
  isAdmin: boolean
  isRecalculate: boolean
}

/**
 * This is the actual store.
 */
const useAppState = create<AppState>()(devtools(
  (set, get) => ({
    editPaymentFreeMonths: false,
    signProcessStarted: false,
    goNextDisabled: false,
    goNextTooltip: undefined,
    redirectBrand: BrandEnum.FKAS,
    isAdmin: false,
    isRecalculate: false,
    setEditPaymentFreeMonths: (editPaymentFreeMonths) => set({editPaymentFreeMonths: editPaymentFreeMonths}),
    setSignProcessStarted: (signProcessStarted) => set({signProcessStarted: signProcessStarted}),
    setGoNextDisabled: (nextDisabled) => set({goNextDisabled: nextDisabled}),
    setGoNextTooltip: (tooltip) => set({goNextTooltip: tooltip}),
    setRedirectBrand: (brand) => set({redirectBrand: brand}),
    setIsAdmin: (isAdmin) => set({isAdmin: isAdmin}),
    setIsRecalculate: (isRecalculate) => set({isRecalculate: isRecalculate})
  })
))

export default useAppState